import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { 
  RiProductHuntLine, 
  RiShoppingBag3Line, 
  RiUser3Line, 
  RiStore2Line 
} from "react-icons/ri";
import { TbTruckReturn } from "react-icons/tb";
import Datatable from '../../component/datatable';
import DatatableOrder from "../../component/datatableorder";
import DatatableReturn from "../../component/datatablereturn";
import DatatableUser from "../../component/datatableuser";
import Loader from '../../component/loader';
import { decrpt } from "../../component/encryption";
import axios from "axios";
import Cookies from "js-cookie";

function Dashboard() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [counts, setCounts] = useState(null);
  const [dataList, setDataList] = useState(null);

  const fetchDashboard = async () => {
    try {
      const token = Cookies.get('s_l');
      if (!token) {
        navigate('../');
        return;
      }
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.get(`/admin/dashboard`);
      if (response.data && response.data.success) {
        setCounts(response.data.counts || {});
        setDataList(response.data.data_list || {});
      } else {
        toast.error("Failed to load dashboard data");
      }
    } catch (error) {
      console.error('Dashboard fetch error:', error);
      if (error?.response?.status === 401) {
        navigate('../');
      }
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoader(true);
    fetchDashboard();
  }, []);

  const newSeller = dataList?.new_sellers || [];
  const orderList = dataList?.order_list || [];
  const returnList = dataList?.return_list || [];
  const userList = dataList?.user_list || [];

  return (
    <div className="main-content">
      {loader && <Loader />}
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar theme="colored" />

      {/* KPI Statistic Cards (5 Cards) */}
      <div className="row g-3 my-2">
        {/* Total Orders */}
        <div className="col-12 col-sm-6 col-md-4 col-xl">
          <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Total Orders</small>
                <h4 className="mb-0 fw-bold text-primary" style={{ fontSize: "22px" }}>
                  {counts?.total_orders !== undefined ? counts.total_orders : (counts?.total_new_orders || 0)}
                </h4>
                <small className="text-muted" style={{ fontSize: "11px" }}>
                  {counts?.total_new_orders || 0} New Orders
                </small>
              </div>
              <div className="p-2 rounded-circle bg-light text-primary" style={{ fontSize: "24px" }}>
                <RiShoppingBag3Line />
              </div>
            </div>
            <div className="mt-2 pt-2 border-top">
              <Link to="../order" className="link-item fw-semibold" style={{ fontSize: "11px" }}>Manage Orders &rarr;</Link>
            </div>
          </div>
        </div>

        {/* Total Products */}
        <div className="col-12 col-sm-6 col-md-4 col-xl">
          <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Total Products</small>
                <h4 className="mb-0 fw-bold text-warning" style={{ fontSize: "22px" }}>
                  {counts?.total_products || 0}
                </h4>
                <small className="text-muted" style={{ fontSize: "11px" }}>
                  {counts?.active_products || 0} Active
                </small>
              </div>
              <div className="p-2 rounded-circle bg-light text-warning" style={{ fontSize: "24px" }}>
                <RiProductHuntLine />
              </div>
            </div>
            <div className="mt-2 pt-2 border-top">
              <Link to="../product" className="link-item fw-semibold" style={{ fontSize: "11px" }}>Product Catalog &rarr;</Link>
            </div>
          </div>
        </div>

        {/* Total Customers */}
        <div className="col-12 col-sm-6 col-md-4 col-xl">
          <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Total Customers</small>
                <h4 className="mb-0 fw-bold text-info" style={{ fontSize: "22px" }}>
                  {counts?.total_users !== undefined ? counts.total_users : (counts?.user_count || 0)}
                </h4>
                <small className="text-muted" style={{ fontSize: "11px" }}>
                  {counts?.user_count || 0} Active
                </small>
              </div>
              <div className="p-2 rounded-circle bg-light text-info" style={{ fontSize: "24px" }}>
                <RiUser3Line />
              </div>
            </div>
            <div className="mt-2 pt-2 border-top">
              <Link to="../user" className="link-item fw-semibold" style={{ fontSize: "11px" }}>Customer List &rarr;</Link>
            </div>
          </div>
        </div>

        {/* Total Sellers */}
        <div className="col-12 col-sm-6 col-md-4 col-xl">
          <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Total Sellers</small>
                <h4 className="mb-0 fw-bold text-secondary" style={{ fontSize: "22px" }}>
                  {counts?.total_sellers !== undefined ? counts.total_sellers : (counts?.seller_count || 0)}
                </h4>
                <small className="text-muted" style={{ fontSize: "11px" }}>
                  {counts?.seller_count || 0} Approved
                </small>
              </div>
              <div className="p-2 rounded-circle bg-light text-secondary" style={{ fontSize: "24px" }}>
                <RiStore2Line />
              </div>
            </div>
            <div className="mt-2 pt-2 border-top">
              <Link to="../seller" className="link-item fw-semibold" style={{ fontSize: "11px" }}>Seller Directory &rarr;</Link>
            </div>
          </div>
        </div>

        {/* Returns */}
        <div className="col-12 col-sm-6 col-md-4 col-xl">
          <div className="card h-100 p-3 shadow-sm border-0" style={{ backgroundColor: "#ffffff" }}>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <small className="text-muted fw-bold text-uppercase d-block" style={{ fontSize: "11px" }}>Returns</small>
                <h4 className="mb-0 fw-bold text-danger" style={{ fontSize: "22px" }}>
                  {counts?.total_returns || 0}
                </h4>
                <small className="text-muted" style={{ fontSize: "11px" }}>
                  Return Requests
                </small>
              </div>
              <div className="p-2 rounded-circle bg-light text-danger" style={{ fontSize: "24px" }}>
                <TbTruckReturn />
              </div>
            </div>
            <div className="mt-2 pt-2 border-top">
              <Link to="../return-orders" className="link-item fw-semibold" style={{ fontSize: "11px" }}>Check Returns &rarr;</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Orders & Returns Row (Side by Side - Equal Width) */}
      <div className="row g-3 my-2">
        {/* Recent Orders (Left) */}
        <div className="col-12 col-lg-6">
          <div className="card p-3 shadow-sm bg-white h-100">
            <div className="card-title d-flex align-items-center justify-content-between pb-2 mb-3">
              <h5 className="mb-0">
                <RiShoppingBag3Line className="me-2 text-primary" /> Recent Orders
              </h5>
              <Link to="../order" className="btn btn-xs btn-warning fw-semibold">View All Orders</Link>
            </div>
            <DatatableOrder orderList={orderList} />
          </div>
        </div>

        {/* Recent Returns (Right) */}
        <div className="col-12 col-lg-6">
          <div className="card p-3 shadow-sm bg-white h-100">
            <div className="card-title d-flex align-items-center justify-content-between pb-2 mb-3">
              <h5 className="mb-0">
                <TbTruckReturn className="me-2 text-danger" /> Recent Returns
              </h5>
              <Link to="../return-orders" className="btn btn-xs btn-warning fw-semibold">View All Returns</Link>
            </div>
            <DatatableReturn returnList={returnList} />
          </div>
        </div>
      </div>

      {/* Recent Users & Sellers Row */}
      <div className="row g-3 pb-4">
        {/* Recent Registered Users */}
        <div className="col-12 col-lg-6">
          <div className="card p-3 shadow-sm bg-white h-100">
            <div className="card-title d-flex align-items-center justify-content-between pb-2 mb-3">
              <h5 className="mb-0">
                <RiUser3Line className="me-2 text-info" /> Latest Registered Users
              </h5>
              <Link to="../user" className="btn btn-xs btn-warning fw-semibold">View All Users</Link>
            </div>
            <DatatableUser userList={userList} />
          </div>
        </div>

        {/* Recent Registered Sellers */}
        <div className="col-12 col-lg-6">
          <div className="card p-3 shadow-sm bg-white h-100">
            <div className="card-title d-flex align-items-center justify-content-between pb-2 mb-3">
              <h5 className="mb-0">
                <RiStore2Line className="me-2 text-secondary" /> Latest Registered Sellers
              </h5>
              <Link to="../seller" className="btn btn-xs btn-warning fw-semibold">View All Sellers</Link>
            </div>
            <Datatable newSeller={newSeller} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
